import SaveBehavior from "@/utils/constants/SaveBehavior.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import OutputFormat from "@/utils/constants/OutputFormat.ts";
import NavigationType from "@/utils/constants/NavigationType.ts";
import PrintAsDialog from "@/components/dialogs/PrintAsDialog.vue";
import BusinessFunction from "@/utils/constants/BusinessFunction.ts";
import NaMaConfirmationDialog from "@/utils/forms/NaMaConfirmationDialog.ts";
import Translator from "@/utils/common/Translator.ts";
import MoreMenuItem, {SimpleEntityMenuItem} from "@/utils/UIConstants/MoreMenuItem.ts";
import SecurityUtils from "@/utils/login/SecurityUtils.ts";
import CapabilityType from "@/utils/constants/CapabilityType.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import GUIUtilities from "@/utils/common/GUIUtilities.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import ActionHandler from "@/utils/moreMenu/ActionHandler.ts";
import GenericActions from "@/utils/constants/GenericActions.ts";
import EditViewPerformer from "@/utils/presenters/EditViewPerformer.ts";
import EntityTypesUtils from "@/utils/common/EntityTypesUtils.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import EntitiesWithLedgerEffectsOrWithParents from "@/utils/constants/EntitiesWithLedgerEffectsOrWithParents.ts";
import BSCEntities from "@/utils/constants/BSCEntities.ts";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import {Dialog} from "quasar";
import ApprovalUtils from "@/utils/editView/ApprovalUtils.ts";
import SimpleEntities from "@/utils/constants/SimpleEntities.ts";
import CriteriaBuilder from "@/utils/criteria/CriteriaBuilder.ts";
import IdsAndConstants from "@/utils/UIConstants/IdsAndConstants.ts";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";
import TooltipsListDialog from "@/components/dialogs/TooltipsListDialog.vue";
import ChatBotDialog from "@/components/navBar/aiassistant/ChatBotDialog.vue";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import {getAISelectedModel} from "@/composables/UseChatModel.ts";
import AIChatMessageType from "@/utils/constants/AIChatMessageType.ts";
import CustomReportLauncherMenuItem from "@/utils/editView/editScreens/CustomReportLauncherMenuItem.ts";
import ShowCustomRepIn from "@/utils/constants/ShowCustomRepIn.ts";
import {ToolbarAction} from "@/utils/presenters/interfaces.ts";
import BaseEntityDTO = namaTypes.BaseEntityDTO;
import GUIActionPlaceholder = namaTypes.GUIActionPlaceholder;
import TemplateMetadata = namaTypes.TemplateMetadata;
import CustomRepInfo = namaTypes.CustomRepInfo;
import DTOApprovalCase = namaTypes.DTOApprovalCase;
import DTOAIChatMessage = namaTypes.DTOAIChatMessage;
import TooltipUtils from "@/utils/common/TooltipUtils.ts";

export default class EditViewToolbarUtils {
  static SAVE: string = "save";
  static SAVE_AND_CONTINUE: string = "saveAndContinue";
  static DUPLICATE: string = "duplicate";
  static SAVE_DRAFT: string = "accept";
  static APPROVAL: string = "approval";
  static REVISE: string = "revise";
  static UNREVISE: string = "unrevise";
  static PRINT: string = "print";
  static PRINT_AS: string = "printAs";
  static LIST_VIEW: string = "listView";
  static ShowHelpMsgs: string = "showHelpMsgs";
  static TOOLTIPS: string = "tooltips";
  static TREE_VIEW: string = "treeView";
  static NEW_RECORD: string = "newRecord";
  static ASK_AI: string = "askAI";
  static DELETE: string = "delete";
  static MORE: string = "more";
  static REFRESH: string = "refresh";
  static HOME_PAGE: string = "homePage";
  static GO_TO_RECORD: string = "goToRecord";
  static FIRST: string = "first";
  static LAST: string = "last";
  static NEXT: string = "next";
  static PREVIOUS: string = "previous";
  static REMOVE_FILTER: string = "removeFilter";
  static ACTIONS: string[] = [EditViewToolbarUtils.SAVE, EditViewToolbarUtils.SAVE_AND_CONTINUE, EditViewToolbarUtils.DUPLICATE,
    EditViewToolbarUtils.SAVE_DRAFT, EditViewToolbarUtils.APPROVAL, EditViewToolbarUtils.REVISE, EditViewToolbarUtils.UNREVISE,
    EditViewToolbarUtils.PRINT, EditViewToolbarUtils.PRINT_AS, EditViewToolbarUtils.LIST_VIEW, EditViewToolbarUtils.ShowHelpMsgs,
    EditViewToolbarUtils.TREE_VIEW, EditViewToolbarUtils.NEW_RECORD, EditViewToolbarUtils.DELETE, EditViewToolbarUtils.MORE,
    EditViewToolbarUtils.REFRESH, EditViewToolbarUtils.HOME_PAGE, EditViewToolbarUtils.GO_TO_RECORD, EditViewToolbarUtils.REMOVE_FILTER,
    EditViewToolbarUtils.ASK_AI];

  static async onToolBarButton(actionId: string, presenter: EditPresenter, emit?: any) {
    await FieldWidgetUtil.saveEditingFieldsAndGrids();
    if (this.NEW_RECORD === actionId)
      await this.onNew(presenter);
    else if (this.SAVE === actionId)
      await this.onSaveClick(presenter);
    else if (this.SAVE_DRAFT === actionId)
      await this.onSaveDraftClick(presenter);
    else if (this.SAVE_AND_CONTINUE === actionId)
      await this.onSaveAndContinueClick(presenter);
    else if (this.DUPLICATE === actionId)
      await this.duplicate(presenter);
    else if (this.REFRESH === actionId)
      await this.refresh(presenter);
    else if (this.PRINT === actionId)
      await this.print(presenter);
    else if (this.PRINT_AS === actionId)
      await this.printAs(presenter);
    else if (this.LIST_VIEW === actionId)
      await this.onGoToListView(presenter);
    else if (this.GO_TO_RECORD === actionId)
      this.onGoToRecord(/*TODO:: toolBarPresenter.getToolBarButtonDiemnsions(actionId)*/null);
    else if (this.FIRST === actionId)
      await this.goToFirstRecord(presenter);
    else if (this.PREVIOUS === actionId)
      await this.goToPreviousRecord(presenter);
    else if (this.NEXT === actionId)
      await this.goToNextRecord(presenter);
    else if (this.LAST === actionId)
      await this.goToLastRecord(presenter);
    else if (this.APPROVAL === actionId)
      await this.onApproval(presenter);
    else if (this.DELETE === actionId)
      await this.deleteRecord(presenter);
    else if (this.TREE_VIEW === actionId)
      this.showTree(emit);
    else if (this.HOME_PAGE === actionId)
      null;//TODO:: GUIUtilities.goToHomePage();
    else if (this.REVISE === actionId)
      await this.markRevised(true, presenter);
    else if (this.ShowHelpMsgs === actionId)
      useNamaFlagsStore().toggleShowHelpMessages();
    else if (this.UNREVISE === actionId)
      await this.markRevised(false, presenter);
    else if (this.TOOLTIPS === actionId)
      await TooltipUtils.showTooltipsList(presenter);
    else if (this.ASK_AI == actionId)
      await this.showAIDialogue(presenter);
    else if (this.REMOVE_FILTER == actionId)
      await this.removeFilter(presenter);
  }

  private static async markRevised(revised: boolean, presenter: EditPresenter) {
    await presenter.markRevised(revised);
  }

  private static async removeFilter(presenter: EditPresenter) {
    await presenter.removeFilter();
  }

  private static async showAIDialogue(presenter: EditPresenter) {
    const selectedModel = getAISelectedModel();
    if (!selectedModel) {
      return;
    }
    await useNamaFlagsStore().initAiChatIdIfNeeded();
    const record = presenter.record.value;
    if (!record) return;

    const req: namaTypes.SendReportOrRecordToAIReq = {
      recordId: record.id,
      recordEntityType: presenter.entityType,
      chatMemoryId: useNamaFlagsStore().aiChatId,
      selectedChatModel: selectedModel
    };

    const resp = await NamaCommon.namaFetch(NamaURLS.SEND_ENTITY_RECORD_TO_AI, {
      data: NamaCommon.stringify(req)
    }) as namaTypes.AIReportPromptResp;

    useNamaFlagsStore().aiChatId = resp.chatId || useNamaFlagsStore().aiChatId;

    let initialMessages: DTOAIChatMessage[] = [
      {
        messageType: AIChatMessageType.User,
        content: Translator.calcByLanguage(
          "أريد مراجعة تفاصيل السجل",
          'I want to review this record'
        )
      },
      {
        messageType: AIChatMessageType.Assistant,
        content: Translator.calcByLanguage(
          "تمت مراجعة كافة تفاصيل السجل",
          'The record details have been reviewed'
        )
      }
    ];
    Dialog.create({
      component: ChatBotDialog,
      componentProps: {
        header: `Chatting about ${presenter.entityType} record: ${record.code || record.id}`,
        presenter,
        initialMessages: initialMessages
      }
    });
  }

  private static showTree(emit: any) {
    if (emit)
      emit('toggleTreeForEditView');
  }

  private static async onApproval(presenter: EditPresenter) {
    let approvalCase: DTOApprovalCase | undefined = presenter.fetchRecord()[CommonFieldIds.CURRENT_APPROVAL_CASE];
    if (!approvalCase)
      return;
    await ApprovalUtils.showApprovalDialog(approvalCase, presenter);
  }

  private static async goToLastRecord(presenter: EditPresenter) {
    await presenter.navigate(NavigationType.Last);
  }

  private static async goToNextRecord(presenter: EditPresenter) {
    if (presenter.isInNewMode())
      await this.goToLastRecord(presenter);
    else
      await presenter.navigate(NavigationType.Next);
  }

  private static async goToPreviousRecord(presenter: EditPresenter) {
    if (presenter.isInNewMode())
      await this.goToFirstRecord(presenter);
    else
      await presenter.navigate(NavigationType.Previous);
  }

  private static async goToFirstRecord(presenter: EditPresenter) {
    await presenter.navigate(NavigationType.First);
  }

  private static onGoToRecord(toolBarButtonDiemnsions: any) {
    /*TODO*/
  }

  private static async onGoToListView(presenter: EditPresenter) {
    await presenter.onGoToListView();
  }

  private static async refresh(presenter: EditPresenter) {
    await presenter.refresh(false, false)
  }

  private static async duplicate(presenter: EditPresenter) {
    await presenter.duplicate();
  }

  private static async onSaveAndContinueClick(presenter: EditPresenter) {
    let isSuccess: boolean = await presenter.doSave(SaveBehavior.SaveAndCommit, true, "", false);
    if (isSuccess)
      await presenter.onNew();
  }

  private static async onSaveDraftClick(presenter: EditPresenter) {
    await presenter.doSave(SaveBehavior.SaveAsDraft, false, "", false);
  }

  private static async onSaveClick(presenter: EditPresenter) {
    await presenter.doSave(SaveBehavior.SaveAndCommit, false, "", false);
  }

  private static async onNew(presenter: EditPresenter) {
    await presenter.onNew();
  }

  private static async print(presenter: EditPresenter) {
    await presenter.print(OutputFormat.PDF, true);
  }

  private static async printAs(presenter: EditPresenter) {
    Dialog.create({
      component: PrintAsDialog,
      componentProps: {
        title: this.PRINT_AS,
      }
    }).onOk((format: string) => {
      if (format)
        if (format === BusinessFunction.sendEmailWithResult)
          presenter.emailResult();
        else
          presenter.print(format, false);
    });

  }

  private static async deleteRecord(presenter: EditPresenter) {
    let isYes: boolean = await NaMaConfirmationDialog.yesNoConfirmationDialog(Translator.translateId("confirmDelete"), true, Translator.translateId("deletTitle"));
    if (isYes) {
      let record: BaseEntityDTO = presenter.record.value!;
      let id = presenter.place.id || record.id;
      let code = record.code;
      await presenter.startDelete(id, code);
    }
  }

  static getMoreMenuItems(presenter: EditPresenter): MoreMenuItem[] {
    let items: MoreMenuItem[] = []
    if (!SecurityUtils.userCan(presenter.entityType, CapabilityType.CanViewMoreMenu))
      return items;
    let standardMoreMenuItems: MoreMenuItem[] = this.getStandardMoreMenuItems(presenter);
    if (presenter.fetchRecord().currentApprovalCase)
      standardMoreMenuItems.push(SimpleEntityMenuItem.fromObject('showCurrentApproval', SimpleEntities.ApprovalCase, presenter.fetchRecord().currentApprovalCase));
    if (standardMoreMenuItems)
      items.push(...standardMoreMenuItems);
    let actionsMoreMenuItems: MoreMenuItem[] | undefined = this.createActionsMoreMenuItems(presenter);
    if (actionsMoreMenuItems)
      items.push(...actionsMoreMenuItems);
    items.push(...this.getExtraMoreMenuItems(presenter));
    return items;
  }

  static getCurrentApprovalAction(): GUIActionPlaceholder {
    return {
      id: "showCurrentApproval",
    }
  }

  private static getExtraMoreMenuItems(presenter: EditPresenter): MoreMenuItem[] {
    let moreMenuItems: MoreMenuItem[] = [];
    let ownerId: string | undefined = presenter.metadata?.owner?.ownerId;
    if (!presenter.isInNewMode()) {
      if (SecurityUtils.userCan(ownerId, CapabilityType.CanViewTransaction)
        && ownerId && EntitiesWithLedgerEffectsOrWithParents.entitiesWithLedgerEffects.contains(ownerId)) {
        moreMenuItems.push(SimpleEntityMenuItem.fromCriteria("showGeneratedSystemTransaction", '', SimpleEntities.LedgerTrans,
          CriteriaBuilder.create().field(IdsAndConstants.trnsData_originId).equal(presenter.record.value?.id).build()));
      }
    }
    let serverDependentItems: MoreMenuItem[] | undefined = presenter.serverDependentMenuItems;
    if (serverDependentItems)
      moreMenuItems.push(...serverDependentItems);
    let entityCustomReports: CustomRepInfo[] = ClientCache.getEntityCustomReports(ownerId);
    if (entityCustomReports) {
      moreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
      for (let customRepInfo of entityCustomReports) {
        if (!customRepInfo.showIn || ObjectChecker.areEqual(customRepInfo.showIn, ShowCustomRepIn.EditViewMore))
          moreMenuItems.push(new CustomReportLauncherMenuItem(presenter, customRepInfo));
      }
    }
    return moreMenuItems;
  }

  private static createActionsMoreMenuItems(presenter: EditPresenter): MoreMenuItem[] | undefined {
    if (!presenter.layout || !presenter.layout.moreActions)
      return;
    let actionsMoreMenuItems: MoreMenuItem[] = [];
    for (let moreAction of presenter.layout.moreActions) {
      if (moreAction.id || moreAction.customization !== null)
        actionsMoreMenuItems.push(new ActionHandler(moreAction, presenter.metadata!, presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    }
    return actionsMoreMenuItems;
  }

  private static getStandardMoreMenuItems(presenter: EditPresenter): MoreMenuItem[] {
    let standardMoreMenuItems: MoreMenuItem[] = [];
    standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem('showErrors', presenter.showErrorsExecuteFn));
    if (ClientCache.getCustomGUISettings()?.showOldBarcodeMenu)
      standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem("printBarcode", presenter.printBarcodeExecuteFn));
    standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem("changeCapabilities", presenter.changeCapabilitiesExecuteFn));
    let record = presenter.record.value!;
    if (!presenter.dispatcher?.isViewOnlyMode()) {
      if (record?.preventUsage)
        standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem("allowUsage", presenter.allowUsageExecuteFn));
      else
        standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem("preventUsage", presenter.preventUsageExecuteFn));
      if (record[CommonFieldIds.PREVENT_USE_AS_FROMDOC])
        standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem("allowUsageAsFromDoc", presenter.allowUsageAsFromDocExecuteFn));
      else
        standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem("preventUsageAsFromDoc", presenter.preventUsageAsFromDocExecuteFn));
    }
    if (record.commitedBefore && record.draftCreated)
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.DISCARD_DRAFT} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    if (presenter.dispatcher?.isApprovalPending())
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.REVOKE_APPROVAL_REQUEST} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    if (useNamaFlagsStore().showEditUIElementProperties)
      standardMoreMenuItems.push(MoreMenuItem.createExportTranslationsMenuItem(presenter));
    let canImport = SecurityUtils.userCan(presenter.entityType, CapabilityType.Import);
    if (useNamaFlagsStore().replicationOptionsActive) {
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.RECOMMIT_RECORD} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      if (GUIUtilities.isEntityWithAccountingEffect(presenter.entityType))
        standardMoreMenuItems.push(new ActionHandler({id: GenericActions.REGEN_ACCOUNTING_EFFECTS} as GUIActionPlaceholder, presenter.metadata!,
          presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      if (EntityTypesUtils.isDocument(presenter.entityType))
        standardMoreMenuItems.push(new ActionHandler({id: GenericActions.REGEN_INVENTORY_EFFECTS} as GUIActionPlaceholder, presenter.metadata!,
          presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      if (ObjectChecker.isAnyEqualToFirst(presenter.entityType, ...EntitiesWithLedgerEffectsOrWithParents.HAS_ACTIVATED_ENTITIES))
        standardMoreMenuItems.push(new ActionHandler({id: "cancelActivated"} as GUIActionPlaceholder, presenter.metadata!,
          presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      if (canImport)
        standardMoreMenuItems.push(new ActionHandler({id: GenericActions.IMPORT_INTO_CURRENT_RECORD} as GUIActionPlaceholder, presenter.metadata!,
          presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.SIMPLE_EXPORT_FOR_DOCS} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      standardMoreMenuItems.push(MoreMenuItem.createShowFieldIdsMenuItem());
      standardMoreMenuItems.push(MoreMenuItem.createOpenEntityDMMenuItem(presenter.entityType));
      standardMoreMenuItems.push(MoreMenuItem.createShowFieldInfoMenuItem());
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.ADD_MANUAL_CODING_PREFIX} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      if (ObjectChecker.areEqual(presenter.entityType, BSCEntities.ReportDefinition)) {
        standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
        standardMoreMenuItems.push(new ActionHandler({id: "updateSystemReports"} as GUIActionPlaceholder, presenter.metadata!,
          presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
        // standardMoreMenuItems.push(RemoteObjectImporter.openImplRepo());
      }
    }
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.VIEW_AUDIT_TRAIL} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.VIEW_DETAILED_AUDIT_TRAIL} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.COMPARE_TWO_VERSIONS} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.SET_AS_TEMPLATE} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    let templates: TemplateMetadata[] = ClientCache.getEntityTemplates(presenter.entityType);
    if (templates) {
      standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
      for (let templateMetadata of templates) {
        if (templateMetadata && !templateMetadata.doNotAddToMoreMenu) {
          standardMoreMenuItems.push(MoreMenuItem.createMoreMenuItem(Translator.translateRef(templateMetadata.template), async () => {
            await presenter.onNew(templateMetadata.template?.id);
          }));
        }
      }
    }
    standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    if (ClientCache.findEntityMaxReviseCount(presenter.entityType).useReviseDocument) {
      if (presenter.canBeRevised())
        standardMoreMenuItems.push(new ActionHandler({id: GenericActions.CREATE_REVISION_DOC} as GUIActionPlaceholder, presenter.metadata!,
          presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      if (presenter.canBeUnRevised())
        standardMoreMenuItems.push(new ActionHandler({id: GenericActions.CREATE_UNREVISION_DOC} as GUIActionPlaceholder, presenter.metadata!,
          presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.VIEW_REVISION_DOCS} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
      standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    }

    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.VIEW_RELATED_DMS_DOCUMENTS} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.CREATE_DMS_DOCUMENT} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());

    standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.VIEW_RELATED_REMARKS} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.CREATE_REMARK} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    if (canImport)
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.IMPORT_RECORDS} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    if (SecurityUtils.userCan(presenter.entityType, CapabilityType.Export))
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.EXPORT_CURRENT} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    if (SecurityUtils.userCan(BSCEntities.ScreenModifier, CapabilityType.EditAfterCommit))
      standardMoreMenuItems.push(new ActionHandler({id: GenericActions.GENERATE_SCREEN_MODIFIER_AND_OPEN_EDITOR} as GUIActionPlaceholder, presenter.metadata!,
        presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.VIEW_RELATED_MEETING_REMARKS} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.CREATE_MEETING_REMARK} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());

    standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.ADDTOAGENDA} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.VIEW_RELATED_DETAILED_REMARKS} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.CREATE_DETAILED_REMARK} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.ADD_TO_CURRENT_USER_FAVOURITES} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(new ActionHandler({id: GenericActions.REMOVE_FROM_CURRENT_USER_FAVOURITES} as GUIActionPlaceholder, presenter.metadata!,
      presenter.entityType, new EditViewPerformer(presenter)).toMoreMenuItem());
    standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    let currentVersion: number | undefined = record?.currentVersion;
    let displayedVersion: number | undefined = presenter.displayedVersion;

    if (!presenter.isInNewMode() && currentVersion && currentVersion > 1) {
      if (!displayedVersion) {
        for (let i = currentVersion - 1; i > 0 && i > currentVersion - 4; i--) {
          standardMoreMenuItems.push(MoreMenuItem.createViewVersions(i, presenter, false))
        }
      } else {
        let startFrom = displayedVersion - 2;
        startFrom = Math.min(startFrom, currentVersion - 6);
        startFrom = Math.max(startFrom, 1);
        let versions: MoreMenuItem[] = [];
        for (let i = startFrom; i < currentVersion && i - startFrom < 3; i++) {
          if (i === displayedVersion)
            continue;
          versions.unshift(MoreMenuItem.createViewVersions(i, presenter, false))
        }
        if (displayedVersion !== currentVersion)
          versions.unshift(MoreMenuItem.createViewVersions(currentVersion, presenter, true));
        standardMoreMenuItems.push(...versions);
      }
      standardMoreMenuItems.push(MoreMenuItem.createShowSpecificVersionMenu(presenter));
      standardMoreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    }
    return standardMoreMenuItems;
  }

  static isActionVisible(action: ToolbarAction) {
    if (!action.checkIfVisible)
      return true;
    return action.checkIfVisible(action);
  }

  static isActionEnabled(action: ToolbarAction) {
    if (!action.checkIfEnabled)
      return true;
    return action.checkIfEnabled(action);
  }

  static isActionDisabled(action: ToolbarAction) {
    return !this.isActionEnabled(action);
  }
}
